import CertificationContainer from './certification-container';

export default CertificationContainer;